/**
 * Typed wrapper for /salescoach/api/practice/*. Mirrors `inbox-api.ts`:
 * `buildApiUrl` strips defaults and resolves the preset; unwrapping the
 * envelope is the hook's job.
 */

import { apiFetch } from '@/services/api';
import { buildApiUrl } from '@/services/api-client';
import type { Filters } from '@/lib/filters-schema';
import type { ApiEnvelope, PracticeDrillRow, PracticeQuarterRow } from './api-types';

export async function fetchPracticeQuarter(
  filters: Filters,
): Promise<ApiEnvelope<PracticeQuarterRow[]>> {
  return apiFetch<ApiEnvelope<PracticeQuarterRow[]>>(
    buildApiUrl('/salescoach/api/practice/quarter', filters),
  );
}

export async function fetchPracticeDrills(
  filters: Filters,
): Promise<ApiEnvelope<PracticeDrillRow[]>> {
  return apiFetch<ApiEnvelope<PracticeDrillRow[]>>(
    buildApiUrl('/salescoach/api/practice/drills', filters),
  );
}
